import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import { LinkButton } from "./LinkButton";
import "./Button.scss";

export const Button = props => {
  const { text, type, onClick, isPlain, isKeyline, isDisabled } = props;

  const className = cx(
    "button", 
    { "button--plain": isPlain },
    { "button--keyline": isKeyline },
    props.className,
  );

  if (type === "link" && !isDisabled) {
    return <LinkButton className={className} {...props} />;
  }

  return (
    <button className={className} disabled={isDisabled} type="button" onClick={onClick}>
    {props.render
    ? props.render()
    :  text || props.children  
    }
    </button>
  );
};

const oneRequired = typeSpecs => (props, propName, componentName) => {
  PropTypes.checkPropTypes(typeSpecs, props, propName, componentName);

  const requiredProps = Object.keys(typeSpecs);

  if (!requiredProps.some(field => props[field])) {
    return new Error(
      `One of ${requiredProps.join(" or ")} is required by '${componentName}' component.`,
    );
  }
};

var oneRequiredRule = {
  text: PropTypes.string,
  children: PropTypes.element,
  render: PropTypes.func,
};

Button.propTypes = {
  text: oneRequired(oneRequiredRule),
  children: oneRequired(oneRequiredRule),
  render: oneRequired(oneRequiredRule),
  onClick: PropTypes.func.isRequired,
  isPlain: PropTypes.bool,
  isDisabled: PropTypes.bool,  
};

Button.defaultProps = {
  isPlain: false,
  isDisabled: false,
  render: null,
};
